import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { CreatePayload, TranslationRequestInput } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = TranslationRequestInput;
type TData = CreatePayload;

export const useTranslationRequestCreate = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation translationRequestCreate($input: TranslationRequestInput!) {
      translationRequestCreate(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
